import style from './undo-icon.module.less';

export const UndoIcon = () => (
  <svg className={style['undo-icon']} fill='none' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M17.5079 12.9487C16.8519 11.3023 15.8015 9.98798 14.3565 9.0056C12.9115 8.02324 11.3033 7.53206 9.532 7.53206C8.23606 7.53206 7.01276 7.81011 5.86211 8.36621C4.71147 8.92231 3.72963 9.70142 2.91661 10.7036L2.91661 7.5L1.66663 7.5L1.66663 12.9487L7.11534 12.9487L7.11534 11.6987L3.70344 11.6987C4.39574 10.7789 5.25098 10.0628 6.26915 9.55048C7.28731 9.03819 8.37226 8.78204 9.52398 8.78204C10.946 8.78204 12.2508 9.15704 13.4383 9.90704C14.6258 10.657 15.5277 11.6709 16.1442 12.9487L17.5079 12.9487Z'
      fill='currentColor'
    />
  </svg>
);
